<template>
  <td :class="[`cell-value-${col}`]">
    <router-link :to="{ name: refEditName, params: { id: entry[col] } }">
      {{ display ? display : entry[col] }}
    </router-link>
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: String,
    editName: String,
    flags: Array,
  },
  computed: {
    refEditName() {
      if (this.col === 'user') {
        return `users-id`;
      }
      return `objects-${this.col}-id`;
    },
  },
  data() {
    return {
      display: null,
    };
  },
  created() {
    if (this.col === 'user') {
      this.find({
        object: 'users',
        id: this.entry[this.col],
        callback: data => {
          this.display = data.username;
        },
      });
    } else {
      this.find({
        object: 'objects',
        type: this.col,
        id: this.entry[this.col],
        callback: data => {
          if (data && data.label) {
            this.display = data.label;
          }
        },
      });
    }
  },
};
</script>
